import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@wds/box';
import { Grid } from '@wds/grid';
import { T, t } from '@sm/intl';
import { Typography } from '@wds/typography';
import { IconCheckCircle, IconFlag } from '@wds/icons';
export const COPY = {
  do: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.do',
    defaultMessage: 'Do',
    description: '[Type: Header][Vis: med] - creating/updating theme name do'
  },
  firstDo: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.firstDo',
    defaultMessage: 'Create themes that represent recurring topics in your responses. For example, if many respondents mention the cost of a product, you could create a theme called "price" to capture this topic.',
    description: '[Type: Header][Vis: med] - selecting themes name first do'
  },
  secondDo: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.secondDo',
    defaultMessage: 'We recommend creating between 5 and 15 themes.',
    description: '[Type: Header][Vis: med] - selecting themes name second do'
  },
  dont: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.dont',
    defaultMessage: "Don't",
    description: "[Type: Header][Vis: med] - selecting keywords title don't"
  },
  firstDont: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.firstDont',
    defaultMessage: 'Create administrative or abstract themes that don’t reflect content in your responses, like “to do” or “follow up.” Auto-tagging applies themes based on response content, and unrelated themes may return inaccurate results.',
    description: '[Type: Header][Vis: med] - selecting keywords first dont'
  },
  iconCheckCircle: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.iconCheckCircle',
    defaultMessage: 'Check icon',
    description: '[Type: Label][Vis: low] - check icon'
  },
  iconFlag: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.iconFlag',
    defaultMessage: 'Flag icon',
    description: '[Type: Label][Vis: low] - flag icon'
  }
};
const ThemeGuidanceCard = () => _jsxs(Grid, {
  noBleeds: true,
  mt: 4,
  children: [_jsxs(Grid.Item, {
    children: [_jsxs(Box, {
      display: "flex",
      justifyContent: "flex-start",
      mb: 4,
      children: [_jsxs(Box, {
        mr: 2,
        children: [_jsx(IconCheckCircle, {
          title: t(COPY.iconCheckCircle),
          color: "primary"
        }), "\u00A0"]
      }), _jsx(Typography, {
        component: "span",
        children: _jsx(T, {
          desc: COPY.do
        })
      })]
    }), _jsxs(Box, {
      children: [_jsx(Typography, {
        component: "div",
        children: _jsx(T, {
          desc: COPY.firstDo
        })
      }), _jsx(Box, {
        mt: 4,
        children: _jsx(Typography, {
          component: "div",
          children: _jsx(T, {
            desc: COPY.secondDo
          })
        })
      })]
    })]
  }), _jsxs(Grid.Item, {
    children: [_jsxs(Box, {
      display: "flex",
      justifyContent: "flex-start",
      mb: 4,
      children: [_jsx(Box, {
        mr: 2,
        children: _jsx(IconFlag, {
          title: t(COPY.iconFlag),
          color: "warning"
        })
      }), "\u00A0", _jsx(Typography, {
        component: "span",
        children: _jsx(T, {
          desc: COPY.dont
        })
      })]
    }), _jsx(Box, {
      children: _jsx(Typography, {
        component: "div",
        children: _jsx(T, {
          desc: COPY.firstDont
        })
      })
    })]
  })]
});
export default ThemeGuidanceCard;